import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const CircleInfoIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="info-circle" {...props} />;
};

export { CircleInfoIcon };
